// The check-in phone, in the browser. Ported from ottos-consult
// src/consult/phoneNumber.js (PORTED-FROM.md). otto-app normalizes to E.164 on
// the server and refuses what it cannot (contract: phone is required); this is
// the friendly first check and the as-you-type format.

/** A full number or "": ten US digits (area code 2 to 9), 1 plus ten US digits, or "+" and 8 to 15 digits. */
export function normalizePhone(value: string): string {
  const raw = String(value ?? "").trim();
  const digits = raw.replace(/\D/g, "");
  if (raw.startsWith("+")) {
    if (digits.startsWith("1")) return digits.length === 11 && /^1[2-9]\d{2}[2-9]/.test(digits) ? `+${digits}` : "";
    return digits.length >= 8 && digits.length <= 15 && /^[1-9]/.test(digits) ? `+${digits}` : "";
  }
  if (digits.length === 10 && /^[2-9]\d{2}[2-9]/.test(digits)) return `+1${digits}`;
  if (digits.length === 11 && /^1[2-9]\d{2}[2-9]/.test(digits)) return `+${digits}`;
  return "";
}

function formatUsDigits(digits: string): string {
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
}

/** As-you-type formatting. A "+" number is left as typed; a leading 1 is read as the country code. */
export function formatPhoneInput(value: string): string {
  const raw = String(value ?? "");
  if (raw.trimStart().startsWith("+"))
    return `+${raw
      .trimStart()
      .slice(1)
      .replace(/[^\d\s().-]/g, "")}`.slice(0, 22);
  const digits = raw.replace(/\D/g, "");
  if (digits.startsWith("1")) {
    const rest = digits.slice(1, 11);
    return rest ? `1 ${formatUsDigits(rest)}` : "1";
  }
  return formatUsDigits(digits.slice(0, 10));
}
